import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-document-references-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './document-references-section.component.html',
})
export class DocumentReferencesSectionComponent {
  readonly documentReferences = input.required<any[]>();

  formatDate(date: string): string {
    if (!date) return '—';
    return /^\d{4}-\d{2}-\d{2}/.test(date) ? date.slice(0, 10) : date;
  }

  getDocType(doc: any): string {
    return doc.type?.coding?.[0]?.display || doc.type?.coding?.[0]?.code || doc.type?.text || '—';
  }

  getDescription(doc: any): string {
    return doc.description || doc.content?.[0]?.attachment?.title || '';
  }

  getDate(doc: any): string {
    return doc.date || doc.context?.period?.start || '';
  }

  getAttachments(doc: any): any[] {
    return (doc.content || []).map((c: any) => c.attachment).filter(Boolean);
  }

  getStatusBadge(status: string): { color: string; label: string } {
    const s = (status || '').toLowerCase();
    if (s === 'current') return { color: 'bg-success', label: 'Vigente' };
    if (s === 'superseded') return { color: 'bg-warning text-dark', label: 'Reemplazado' };
    if (s === 'entered-in-error') return { color: 'bg-danger', label: 'Error de Entrada' };
    return { color: 'bg-secondary', label: status || '—' };
  }
}
